import { createAsyncThunk } from '@reduxjs/toolkit';
import api, { MeResponse } from 'api';
import storage from 'utils/storageController';

import { AxiosResponse } from 'api';
import { loadPermissions } from '../permissions/permissions-middleware';
import { queryClient } from 'queryClient';
import { fetchProfilePictureUrl, profilePictureKeys } from 'hooks/useMyAccount';

export const loadUserFullInfo = createAsyncThunk(
    'app/loadUserFullInfo',
    async (_, { dispatch }) => {
        const meResponse = await dispatch(loadMe());
        storage.setUserRole((meResponse.payload as AxiosResponse<MeResponse>).data.role);
        // Prefetch into react-query cache (shared with useProfilePicture)
        await queryClient.prefetchQuery({
            queryKey: profilePictureKeys.all,
            queryFn: fetchProfilePictureUrl,
        });
        const userId = (meResponse.payload as AxiosResponse<MeResponse>).data.id;
        if (userId) {
            await dispatch(loadPermissions(userId));
        }
    }
);

export const loadMe = createAsyncThunk('api/me', async () => {
    return await api.me.get();
});
